export const CatalogueWiseDataShimmer = ({ isDark }) => {
  const pageBg = isDark ? "bg-gray-100" : "bg-[#f4f6fb]";
  const cardBg = isDark ? "bg-gray-100" : "bg-white";
  const skeletonPrimary = isDark ? "bg-slate-700" : "bg-gray-300";
  const skeletonSecondary = isDark ? "bg-slate-600" : "bg-gray-200";
  const borderColor = isDark ? "border-slate-700" : "border-gray-200";

  const shimmerGradient = isDark
      ? "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700"
      : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300";

  return (
      <div className={`${pageBg} min-h-screen p-5 transition-colors duration-300`}>
        <div className="flex gap-5">

          {/* Sidebar shimmer */}
          <aside
              className={`w-1/4 ${cardBg} rounded-xl shadow-md p-4 hidden md:block`}
          >
            <div
                className={`h-6 w-24 mx-auto mb-4 rounded animate-shimmer ${skeletonPrimary}`}
            />

            {[1, 2, 3].map((i) => (
                <div key={i} className="mb-4">
                  <div
                      className={`h-4 w-32 rounded mb-2 animate-shimmer ${skeletonPrimary}`}
                  />

                  {[1, 2, 3].map((j) => (
                      <div
                          key={j}
                          className={`h-3 w-full rounded mb-2 animate-shimmer ${skeletonSecondary}`}
                      />
                  ))}
                </div>
            ))}
          </aside>

          {/* Products shimmer */}
          <main className="flex-1">
            <div className={`${cardBg} p-4 rounded-md shadow-sm`}>

              {/* Header shimmer */}
              <div className="flex justify-between items-center mb-4">
                <div>
                  <div
                      className={`h-4 w-32 rounded mb-2 animate-shimmer ${skeletonPrimary}`}
                  />
                  <div
                      className={`h-3 w-24 rounded animate-shimmer ${skeletonSecondary}`}
                  />
                </div>

                <div
                    className={`h-8 w-32 rounded animate-shimmer ${skeletonPrimary}`}
                />
              </div>

              {/* Product grid shimmer */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {Array.from({ length: 8 }).map((_, index) => (
                    <div
                        key={index}
                        className={`border ${borderColor} ${cardBg} rounded-[10px] overflow-hidden`}
                    >

                      {/* Image */}
                      <div
                          className={`w-full aspect-product-desktop relative overflow-hidden ${skeletonPrimary}`}
                      >
                        <div
                            className={`absolute inset-0 animate-shimmer bg-[length:200%_100%] ${shimmerGradient}`}
                        />
                      </div>

                      {/* Text */}
                      <div className="p-3 space-y-2">
                        <div
                            className={`h-4 w-3/4 rounded animate-shimmer ${skeletonPrimary}`}
                        />
                        <div
                            className={`h-4 w-1/2 rounded animate-shimmer ${skeletonSecondary}`}
                        />
                        <div
                            className={`h-8 w-full rounded animate-shimmer ${skeletonPrimary}`}
                        />
                      </div>
                    </div>
                ))}
              </div>

            </div>
          </main>
        </div>
      </div>
  );
};